import { oneLineTrim } from 'common-tags';
import {
    includeParam,
    filterParam,
    limitAllParam as pageSizeAllParam,
} from 'app/react/state/middleware/api'

const root = (eventId) => `events/${eventId}/artists/item-groups`;

export const fetchAll = (
    eventId,
    filters = {},
    includes = []
) => oneLineTrim`
    ${root(eventId)}?
    ${pageSizeAllParam}&
    ${filterParam(filters)}&
    ${includeParam(includes)}&
`;

export const createOne = (
    eventId
) => oneLineTrim`
    ${root(eventId)}
`;

export const updateOne = (
    eventId,
    groupId
) => oneLineTrim`
    ${root(eventId)}/${groupId}
`;

export const deleteOne = (
    eventId,
    groupId
) => oneLineTrim`
    ${root(eventId)}/${groupId}
`;
